import React from 'react'
import { useHistory } from 'react-router-dom'
import AbbeHappy from 'resources/graphics/abbe_happy.png'
import { Typography, Button } from '@astrid/components'
import { useSelector } from 'react-redux'
import { selectCurrentUser, signOut } from 'store/services/User'
import styles from './VerifyEmail.module.scss'
import useThunkDispatch from 'hooks/useThunkDispatch'

const VerifyEmail: React.FC = () => {
  const user = useSelector(selectCurrentUser)
  const history = useHistory()
  const dispatch = useThunkDispatch()

  return (
    <div className={styles.container}>
      <img src={AbbeHappy} alt="Abbe" />
      <Typography variant="h3">Confirm your email</Typography>
      <Typography variant="body">We've sent you an activation email to: {user?.username}</Typography>
      <Button
        onClick={() => {
          history.push(`/`)
          dispatch(signOut)
        }}
      >
        Back to login
      </Button>
    </div>
  )
}

export default VerifyEmail
